module.exports = __webpack_public_path__ + "img/1.f5e99e0c.jpg";